<template>
  <div>
    <MainHeader></MainHeader>
    <MainContent></MainContent>
    <MainFooter></MainFooter>
  </div>

</template>

<script>
import MainHeader from "@/components/MainHeader";
import MainContent from "@/components/MainContent";
import MainFooter from "@/components/MainFooter";

export default {
  name: 'HomePage',
  components: {MainHeader, MainContent, MainFooter}
}

</script>

<style>
.el-input input.el-input__inner {
  font-size: medium !important; /* 使用 !important 提高优先级 */
}

.el-form-item__label {
  font-size: medium !important;
  justify-content: start !important; /* 对齐到左边 */
  text-align: left !important;
  width: 100px !important;
}

.el-form-item__error {
  font-size: 16px !important; /* 修改为你想要的字体大小 */
}

.el-button {
  font-size: medium !important; /* 使用!important提高优先级 */
}

.el-dialog__header {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-right: 0 !important;
  /*background: #3378df;*/
  /*border-bottom: solid 2px #3378df;*/
  font-size: 20px !important;
  /*  overflow: hidden;*/
  border: none;
  /*width: 650px;*/
}

.el-dialog__body {
  padding-top: 5px !important;
  padding-right: 0 !important;
  overflow: hidden;
  /*overflow-y: auto;*/
  font-size: 18px !important;
}

.el-dialog__title {
  /*color: #fff !important;*/
  line-height: 24px;
}

.el-dialog__headerbtn {
  padding-right: 0 !important;
  /*padding-left: 30px !important;*/
}

.el-cascader-panel {
  font-size: 16px !important;
}

.el-message-box {
  width: 350px !important;
}

.el-message-box .el-message-box__title {
  /*font-size: 30px !important;*/
  height: 80px;
  /*width: 350px;*/
  border: none;
  background-image: url('@/assets/picture/messageBox.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.el-message-box .el-message-box__header {
  padding: 0;
}

.el-message-box .el-message-box__content {
  font-size: 18px !important; /* 修改字体大小 */
  min-height: 30px;
  /*margin-left: 50px;*/
  margin-top: 20px;
  margin-bottom: 20px;
  /*background-image: url('@/assets/picture/messageBoxContent.png');*/
  /*background-size: cover;*/
}

/*  top: 8px !important;*/
/*  background-image: url("../assets/picture/main/slide/arrow.png");*/
/*  background-repeat: no-repeat;*/
/*  background-position: right;*/
/*  background-size: cover;*/
/*  background-color: red;*/
/*}*/

/*.el-dialog__headerbtn i {*/
/*  font-size: 25px;*/
/*  visibility: hidden;*/
/*}*/


/*.el-dialog__headerbtn {*/
/*  position: absolute;*/
/*  top: 40%;*/
/*  transform: translateY(-40%);*/
/*  right: 20px; !* 根据padding的改变调整右边距 *!*/
/*}*/

/*.el-dialog__headerbtn .el-dialog__close {*/
/*  !*padding-top: 0 !important;*!*/
/*  background-color: #f56c6c;*/
/*  color: #fff !important;*/
/*}*/

/*.el-dialog__headerbtn .el-dialog__close :hover {*/
/*  background-color: #3378df;*/
/*  color: #fff !important;*/
/*}*/

</style>
